<template>
  <v-row>
    <v-col v-for="(detail,i) in details.data" :key="i" align="center" cols="12" md="3">
      <v-card class="customer-card dt-border">
        <v-menu depressed transition="slide-y-transition" bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="right: 10px; top: 10px"
              v-bind="attrs"
              v-on="on"
              absolute
              color="#797979"
              icon
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <p>Heeeey</p>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-badge bordered bottom :color="status(detail)" offset-x="32" offset-y="32" dot>
          <v-avatar size="120px" class="customer-image">
            <img v-if="detail.profile.profilepicture" :src="detail.profile.profilepicture" alt="John" />
            <v-icon v-if="!detail.profile.profilepicture" dark size="60">
              mdi-account-circle
            </v-icon>
          </v-avatar>
        </v-badge>
        <h4>{{detail.profile.firstname + ' ' + detail.profile.lastname}}</h4>
        <p>{{detail.email}}</p>
        <p>{{detail.phonenumber}}</p>
        <v-btn :to="'/customers/' + detail.id" :disabled="false" color="transparent" depressed class="customer-btn">
          View
        </v-btn>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
    props:{
        details:{
            type:Object
        }
    },
    methods:{
      status(detail){
        let color = ( detail.status === 'active' ) ? 'green' : 'red'
        return color
      },
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/Global/scss/variables.scss";

.customer-card {
  padding: 20px;
  margin: auto;
  box-shadow: none !important;
  border-radius: 7px !important;
  background: $Dtunes-offwhite;

  .customer-image {
    border: 3px solid #ffffff;
    margin-bottom: 15px;
  }
  img{
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }
  h4 {
    font-size: 18px;
    font-weight: 500;
    color: $Dtunes-text;
    margin-bottom: 5px;
  }
  p {
    font-size: 14px;
    color: $Dtunes-grey;
    letter-spacing: 0.5px;
    margin-bottom: 10px;
  }
  .customer-btn {
      margin-top:10px;
    // box-shadow: none !important;
    font-size:14px;
    color: $Dtunes-orange;
    padding: 10px 40px;
  }
}
.v-menu__content{
    box-shadow: 0px 1px 18px rgba(0, 0, 0, 0.1) !important;
    border-radius: 5px; 
  }
</style>